module.exports = __webpack_public_path__ + "static/media/twitter.43dcdcf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/twitter.svg
// module id = 232
// module chunks = 0